import React from 'react';
import { BRW } from '../mock';

export const BRWBadge = ({ height = 92 }) => (
  <div
    className="shrink-0 bg-white"
    style={{ padding: 8, boxShadow: '0 12px 30px -14px rgba(0,0,0,0.75)' }}
  >
    <img
      src="/images/brw-covers.png"
      alt="BRW magazine featuring Craig Duffy"
      style={{ height, width: 'auto', display: 'block' }}
    />
  </div>
);

const BRWStrip = () => (
  <section className="bg-navy">
    <div className="dig-container py-10 md:py-12">
      <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10">
        <BRWBadge height={96} />
        <div className="text-center md:text-left">
          <h3 className="font-serif-dig gold-text" style={{ fontSize: '1.5rem', fontWeight: 700, letterSpacing: '0.02em' }}>
            {BRW.headline}
          </h3>
          <p className="font-body text-white mt-3" style={{ fontSize: '1.05rem', fontWeight: 600 }}>
            {BRW.name}
          </p>
          <p className="font-body mt-1" style={{ color: 'rgba(255,255,255,0.72)' }}>
            {BRW.sub}
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default BRWStrip;
